export const lolApiVersion: string = '16.17.1'; //* It has to be updated as a new champion is added
